import 'vant/es/toast/style';
export default {
  data() {
    return {
      lang: 'hk',
      userTerms: []
    };
  },
  components: {},
  methods: {}
};